var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './UpdatePlanModal.view.html';
import { StudioService } from '../../services/StudioService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import SparkleGradientIcon from 'assets/img/icons/sparkle-ai-gradient.svg';
import './UpdatePlanModal.scss';
import { PlanStatus } from '../../types/plan';
let UpdatePlanModalComponent = class UpdatePlanModalComponent {
    static $inject = ['StudioService', '$translate', 'BlipToastService'];
    constructor(StudioService, $translate, BlipToastService) {
        'ngInject';
        this.StudioService = StudioService;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.sparkleGradientIcon = SparkleGradientIcon;
        this.isLoading = true;
        this.showUpgradeButton = false;
        this.initProperties = async () => {
            this.status = (await this.StudioService.isTrialExpired()) ? 'expired' : 'ongoing';
            this.showUpgradeButton = (await this.StudioService.shouldShowTrialRegisterOption()) === PlanStatus.AVAILABLE_TO_UPGRADE;
            this.isLoading = false;
        };
        this.upgradePlan = async () => {
            try {
                await this.StudioService.upgradePlan({ origin: this.origin });
                this.BlipToastService.show('success', {
                    title: this.$translate.instant('updatePlanModal.toasts.success.title'),
                    msg: this.$translate.instant('updatePlanModal.toasts.success.message'),
                });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    title: this.$translate.instant('updatePlanModal.toasts.error.title'),
                    msg: this.$translate.instant('updatePlanModal.toasts.error.message'),
                });
            }
        };
        this.closeModal = () => {
            if (this.close) {
                this.close();
            }
        };
        this.initProperties();
    }
};
UpdatePlanModalComponent.$inject = ['StudioService', '$translate', 'BlipToastService'];
UpdatePlanModalComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template,
        bindings: {
            close: '&?',
            origin: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof StudioService !== "undefined" && StudioService) === "function" ? _a : Object, typeof (_c = typeof angular !== "undefined" && (_b = angular.translate) !== void 0 && _b.ITranslateService) === "function" ? _c : Object, typeof (_d = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _d : Object])
], UpdatePlanModalComponent);
export { UpdatePlanModalComponent };
